export default __webpack_public_path__ + "static/media/lineCapCircle.0168e4a5.svg";